import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
const ViewButton = (props) => {
  const { value } = props;

  return (
    <span onClick={() => {}}>
      <FontAwesomeIcon icon={['fas', 'eye']} size="sm" />
    </span>
  );
};

export default ViewButton;
